import {Injectable} from '@angular/core';
import {SignalEntityQuery} from '../../state/signal-entity.store';
import {SuperflowState, SuperflowStore} from './superflow.store';
import {SuperflowItem} from '../../models/underwriter.model';

@Injectable({providedIn: 'root'})
export class SuperflowQuery extends SignalEntityQuery<SuperflowItem, SuperflowState>{
    constructor(protected store: SuperflowStore) {
        super(store);
    }
}
